<div class="devtools-grid-container">
  <div class="devtools-grid-wrapper" #devtoolsGrid>
    <hs-devtools-grid
      #devToolsSSE
      [eventStream]="eventStream$ | async"
      (toggleIsPlaying)="onPlay($event)"
      (clear)="onClearData()"
      [token]="token$ | async"
    ></hs-devtools-grid>
  </div>

  <hs-resize-handle
    [elem1]="devtoolsGrid"
    [elem2]="devtoolsSubPanels"
    [initialResizeHandleState]="state?.resizeHandleState"
    (resizeFinished)="onResizeFinished($event)"
  ></hs-resize-handle>

  <div id="devtools-sub-panels" #devtoolsSubPanels>
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li [ngbNavItem]="1">
        <a class="jobs-nav-item" ngbNavLink>Http Requests</a>
        <ng-template ngbNavContent>
          <hs-dev-tools-http
            #devToolsHttp
            [httpStream]="recordedHttpRequests$ | async"
            [clearHttp]="clearHttpSubject"
          ></hs-dev-tools-http>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
  </div>
</div>
